/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Something_Went_Wrong_DescriptionInputs */

const en_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again in a few minutes.
(Error code: [%s])`)
};

const ar_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى المحاولة مرة أخرى بعد بضع دقائق.
(رمز الخطأ: [%s])`)
};

const de_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte versuche es in ein paar Minuten erneut.
(Fehlercode: [%s])`)
};

const es_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuelve a intentarlo en unos minutos.
(Código de error: [%s])`)
};

const fr_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez réessayer dans quelques minutes.
(Code d’erreur : [%s])`)
};

const it_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova tra qualche minuto.
(Codice errore: [%s])`)
};

const ja_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数分後にもう一度お試しください。
（エラーコード：[%s]）`)
};

const ko_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몇 분 후에 다시 시도해 주세요.
(오류 코드: [%s])`)
};

const pt_br_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente novamente em alguns minutos.
(Código de erro: [%s])`)
};

const ru_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторите попытку через несколько минут.
(Код ошибки: [%s])`)
};

const th_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดลองอีกครั้งในอีกไม่กี่นาที
(รหัสข้อผิดพลาด: [%s])`)
};

const tr_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen birkaç dakika sonra tekrar dene.
(Hata kodu: [%s])`)
};

const zh_cn_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请稍候几分钟后重试。
（错误码：[%s]）`)
};

const zh_tw_dialog_something_went_wrong_description = /** @type {(inputs: Dialog_Something_Went_Wrong_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請稍候幾分鐘再試。
（錯誤碼：[%s]）`)
};

/**
* | output |
* | --- |
* | "Please try again in a few minutes. (Error code: [%s])" |
*
* @param {Dialog_Something_Went_Wrong_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_something_went_wrong_description = /** @type {((inputs?: Dialog_Something_Went_Wrong_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Something_Went_Wrong_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_something_went_wrong_description(inputs)
	if (locale === "ar") return ar_dialog_something_went_wrong_description(inputs)
	if (locale === "de") return de_dialog_something_went_wrong_description(inputs)
	if (locale === "es") return es_dialog_something_went_wrong_description(inputs)
	if (locale === "fr") return fr_dialog_something_went_wrong_description(inputs)
	if (locale === "it") return it_dialog_something_went_wrong_description(inputs)
	if (locale === "ja") return ja_dialog_something_went_wrong_description(inputs)
	if (locale === "ko") return ko_dialog_something_went_wrong_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_something_went_wrong_description(inputs)
	if (locale === "ru") return ru_dialog_something_went_wrong_description(inputs)
	if (locale === "th") return th_dialog_something_went_wrong_description(inputs)
	if (locale === "tr") return tr_dialog_something_went_wrong_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_something_went_wrong_description(inputs)
	return zh_tw_dialog_something_went_wrong_description(inputs)
});